import type { JSX } from 'preact';

interface TextareaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  id?: string;
  className?: string;
}

export function Textarea({
  value,
  onChange,
  placeholder,
  rows = 4,
  id,
  className,
}: TextareaProps) {
  const handleInput = (e: JSX.TargetedEvent<HTMLTextAreaElement>) => {
    onChange(e.currentTarget.value);
  };

  return (
    <textarea
      value={value}
      onInput={handleInput}
      placeholder={placeholder}
      rows={rows}
      id={id}
      class={className}
    />
  );
}
